export default __webpack_public_path__ + "static/media/connect-white.3b699d1a.svg";